


import React from 'react';

import Materialsled from './Materialsled';
import Plasticcompared from './Plasticcompared';
import Moldaluminum from './Moldaluminum';


const Materialsledlig = () => {
    return (
        <div>
            <Materialsled />
            <Plasticcompared />
            <Moldaluminum />

        </div>
    );
};

export default Materialsledlig;
